export default function offsetTop(element) {
    let offset = 0;
    while (element !== document.body) {
        offset += element.offsetTop;
        element = element.parentNode;
    }
    return offset;
}
